import { Filter2, SearchBarComponent } from 'components/index'
import { useState, useEffect } from 'react'
import SearchDates from 'components/SearchDates/SearchDates'
import { Icon } from 'assets/index'
import { FilterContainer, MainContainer } from './style'
import TransactionTable from '../TransactionTable'
import { formatExtract, pixTypeOptions, statusOptions } from './factory'

interface ExtractProps {
  initalData: any[]
  dateRange: {
    startDate: Date | null
    endDate: Date | null
  }
  setDateRange: React.Dispatch<
    React.SetStateAction<{
      startDate: Date | null
      endDate: Date | null
    }>
  >
}

export default function Extract(props: ExtractProps) {
  const { initalData, dateRange, setDateRange } = props

  const [selectedPixType, setSelectedPixType] = useState<any>(null)
  const [selectedStatus, setSelectedStatus] = useState<any>(null)
  const [filteredData, setFilteredData] = useState<any>(initalData)
  const [documentoCliente, setDocumentoCliente] = useState<string>('')
  const [showDataPicker, setShowDataPicker] = useState(false)

  useEffect(() => {
    // *************************************************************
    // FILTRAR DADOS DO EXTRATO
    // *************************************************************
    const filters: ((item: any) => boolean)[] = []

    const isNumber = (value: string): boolean => {
      value = value.trim().replace(/[.,()-\s]/g, '')
      return /^[0-9]+$/.test(value)
    }

    if (documentoCliente) {
      const normalize = (str: string) => str.replace(/[.\-\/\s]/g, '')

      filters.push((item) => {
        const nameMatch = item?.name
          ?.toLowerCase()
          ?.includes(documentoCliente.toLowerCase())

        const docMatch = normalize(String(item?.document || '')).includes(
          normalize(documentoCliente)
        )
        const phoneMatch = String(item?.telefone || '').includes(
          documentoCliente
        )

        return isNumber(documentoCliente) ? docMatch || phoneMatch : nameMatch
      })
    }
    if (selectedPixType?.value) {
      if (selectedPixType.value === 'FEE') {
        filters.push((item) =>
          String(item?.type || '')
            .toUpperCase()
            .includes('FEE')
        )
      } else {
        filters.push((item) => item?.pixKeyType === selectedPixType.value)
      }
    }

    if (selectedStatus?.value) {
      filters.push((item) => item?.status === selectedStatus.value)
    }

    if (dateRange?.startDate || dateRange?.endDate) {
      filters.push((item) => {
        const date = item?.date ? new Date(item.date) : null
        const start = dateRange?.startDate
          ? new Date(dateRange.startDate)
          : null
        const end = dateRange?.endDate ? new Date(dateRange.endDate) : null

        if (!date) return false

        if (start && end) {
          return date >= start && date <= end
        }

        if (start) {
          return (
            date.getFullYear() === start.getFullYear() &&
            date.getMonth() === start.getMonth() &&
            date.getDate() === start.getDate()
          )
        }

        if (end) {
          return (
            date.getFullYear() === end.getFullYear() &&
            date.getMonth() === end.getMonth() &&
            date.getDate() === end.getDate()
          )
        }

        return false
      })
    }
    // Aplica todos os filtros sobre os dados iniciais
    const newFiltered = initalData?.filter((item: any) =>
      filters.every((filter) => filter(item))
    )

    setFilteredData(newFiltered)
  }, [initalData, documentoCliente, selectedPixType, selectedStatus, dateRange])

  console.log('Format Extract', formatExtract(filteredData))

  return (
    <MainContainer>
      <span className="title">Histórico</span>
      <FilterContainer>
        <SearchBarComponent
          width="mediumSmall"
          dataTestId="search-name-tel-document"
          placeholder={'Pesquisar por Nome; CPF e CNPJ'}
          onChange={(e: any) => {
            setDocumentoCliente(e.target.value)
          }}
          value={documentoCliente}
          isClearable
          onClear={() => setDocumentoCliente('')}
        />
        <SearchDates
          dateRange={dateRange}
          setDateRange={setDateRange}
          setShowDataPicker={setShowDataPicker}
          showDataPicker={showDataPicker}
        />
        <Filter2
          options={pixTypeOptions}
          placeholder="Tipo de operação"
          selected={selectedPixType}
          setSelected={setSelectedPixType}
          dataTestId="filter-pix-type"
          icon={Icon('dollar.svg')}
          isClearable
        />

        <Filter2
          options={statusOptions}
          placeholder="Status"
          selected={selectedStatus}
          setSelected={setSelectedStatus}
          dataTestId="filter-status"
          icon={Icon('filter.svg')}
          isClearable
        />
      </FilterContainer>

      <TransactionTable data={formatExtract(filteredData)} />
    </MainContainer>
  )
}
